import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { posts } from 'store/modules/consultancy_legal_store/actions';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from 'store';
import { ConsultancyLegalState } from 'store/modules/consultancy_legal_store/types';
import Loader from 'components/atoms/loader';
import { Container } from './styles';

interface DicaPostProps {
  params: {
    id?: string;
  };
}

const DicaPost = (props: DicaPostProps) => {
  const { params } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    params?.id && dispatch(posts(params?.id));
  }, []);

  const { dica_legal, request } = useSelector<ApplicationState, ConsultancyLegalState>(
    (state) => state.session.dica_legal,
  );

  return (
    <div className="page-container">
      <div className="container">
        <div className="row">
          <div className="col-md-12 mt-4">
            <Link to="/consultoria_juridica">
              <i className="material-icons align-middle">keyboard_arrow_left</i> Voltar
            </Link>
            {request?.posts?.loading ? (
              <Loader />
            ) : (
              <Container className="card mt-4 p-md-4 p-0">
                <div className="card-body">
                  <h4>{dica_legal?.post[0]?.title}</h4>
                  <hr />
                  <p
                    dangerouslySetInnerHTML={{
                      __html: dica_legal?.post[0]?.post_tip?.content?.rendered || '-',
                    }}
                  />
                </div>
              </Container>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export { DicaPost };
